export default __webpack_public_path__ + "static/media/error.d345233c.svg";